/* 70x7 Faithful — theme scripts (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { cartType: 'page', routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };

  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Header offset for mobile menu ---------- */
  const setHeaderOffset = () => {
    const h = $('.site-header');
    if (h) document.documentElement.style.setProperty('--header-bottom', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
  };
  window.addEventListener('resize', setHeaderOffset);
  window.addEventListener('scroll', setHeaderOffset, { passive: true });
  document.addEventListener('DOMContentLoaded', setHeaderOffset);

  $$('[data-mobile-nav]').forEach((d) => {
    d.addEventListener('toggle', () => {
      setHeaderOffset();
      document.documentElement.classList.toggle('no-scroll', d.open);
    });
  });

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Cart drawer ---------- */
  const drawer = () => $('#CartDrawer');
  const useDrawer = () => T.cartType === 'drawer' && !!drawer();
  let lastFocus = null;

  function openCart() {
    const d = drawer();
    if (!d) { window.location.href = T.routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    const btn = $('[data-cart-close-btn]', d);
    if (btn) setTimeout(() => btn.focus(), 50);
  }
  function closeCart() {
    const d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  async function updateCount() {
    try {
      const r = await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      const c = await r.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    } catch (e) { /* no-op */ }
  }
  async function refreshDrawer(sections) {
    try {
      if (!sections) {
        const r = await fetch(T.routes.root + '?sections=cart-drawer');
        sections = await r.json();
      }
      const html = sections && sections['cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = $('#CartDrawerInner', doc);
        const cur = $('#CartDrawerInner');
        if (next && cur) cur.replaceWith(next);
      }
    } catch (e) { /* no-op */ }
    updateCount();
  }

  document.addEventListener('click', async (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && useDrawer()) { e.preventDefault(); openCart(); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    const change = e.target.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      change.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(T.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(change.dataset.line), quantity: Math.max(0, Number(change.dataset.qty)), sections: 'cart-drawer' })
        });
        const data = await r.json();
        await refreshDrawer(data.sections);
      } catch (err) { window.location.reload(); }
      return;
    }

    const modalOpen = e.target.closest('[data-modal-open]');
    if (modalOpen) {
      const dlg = document.getElementById(modalOpen.dataset.modalOpen);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeCart();
    $$('[data-mobile-nav][open]').forEach((d) => { d.open = false; });
  });

  /* ---------- Add to cart (AJAX when drawer is on) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !useDrawer()) return;
    e.preventDefault();
    const buttons = $$('[data-atc]');
    const errorEl = $('[data-form-error]', form);
    buttons.forEach((b) => { b.setAttribute('aria-busy', 'true'); });
    if (errorEl) errorEl.hidden = true;
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await r.json();
      if (data.status) {
        if (errorEl) { errorEl.textContent = data.description || data.message || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
      } else {
        await refreshDrawer(data.sections);
        openCart();
      }
    } catch (err) {
      form.submit();
    } finally {
      buttons.forEach((b) => b.removeAttribute('aria-busy'));
    }
  });

  /* ---------- Cart page: auto-update quantity ---------- */
  $$('[data-cart-qty]').forEach((input) => input.addEventListener('change', () => input.form.submit()));

  /* ---------- Collection sort ---------- */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }));

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    let inventory = {};
    try { inventory = JSON.parse(($('[data-inventory-json]', root) || {}).textContent || '{}'); } catch (e) { /* ignore */ }
    const lowThreshold = Number(root.dataset.lowStock || 0);
    const lowMsg = $('[data-low-stock-msg]', root);
    const lowTpl = lowMsg ? $('[data-low-stock-text]', lowMsg).textContent : '';

    const selectedOptions = () => $$('fieldset[data-option-position]', root)
      .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
      .map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });

    const showLowStock = (variant) => {
      if (!lowMsg) return;
      const qty = variant ? inventory[String(variant.id)] : null;
      if (variant && variant.available && typeof qty === 'number' && qty > 0 && lowThreshold > 0 && qty <= lowThreshold) {
        $('[data-low-stock-text]', lowMsg).textContent = lowTpl.replace('[count]', qty);
        lowMsg.hidden = false;
      } else {
        lowMsg.hidden = true;
      }
    };

    const goToMedia = (id) => {
      const slides = $('[data-gallery-slides]', root);
      const slide = id && $(`[data-media-id="${id}"]`, root);
      if (slides && slide) slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    };

    const update = () => {
      const opts = selectedOptions();
      const v = product.variants.find((variant) => variant.options.every((o, i) => o === opts[i]));
      $$('fieldset[data-option-position]', root).forEach((fs, i) => {
        const lbl = $('[data-option-value]', fs);
        if (lbl) lbl.textContent = opts[i];
      });
      $$('[data-atc]', root).forEach((b) => {
        b.disabled = !v || !v.available;
        const t = $('[data-atc-text]', b);
        if (t) t.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
      });
      if (!v) { showLowStock(null); return; }
      $$('[data-variant-id]', root).forEach((i) => { i.value = v.id; });
      $$('[data-price]', root).forEach((p) => { p.textContent = money(v.price); });
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-compare]', root).forEach((c) => { c.hidden = !onSale; if (onSale) c.textContent = money(v.compare_at_price); });
      $$('[data-save]', root).forEach((s) => { s.hidden = !onSale; if (onSale) s.textContent = 'You save ' + money(v.compare_at_price - v.price); });
      showLowStock(v);
      if (v.featured_media) goToMedia(v.featured_media.id);
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    };

    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-input]')) update(); });

    // initial low-stock state
    const initId = ($('[data-variant-id]', root) || {}).value;
    showLowStock(product.variants.find((v) => String(v.id) === String(initId)));

    // quantity stepper
    $$('[data-qty-step]', root).forEach((btn) => btn.addEventListener('click', () => {
      const input = $('[data-qty-input]', root);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qtyStep));
    }));

    // gallery thumbs
    const slides = $('[data-gallery-slides]', root);
    const thumbs = $$('[data-thumb]', root);
    thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.thumb)));
    if (slides && thumbs.length) {
      slides.addEventListener('scroll', () => {
        const idx = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      }, { passive: true });
    }

    // sticky add to cart
    const sticky = $('[data-sticky-atc]', root);
    const mainAtc = $('[data-main-atc]', root);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach((b) => { b.tabIndex = show ? 0 : -1; });
      }).observe(mainAtc);
    }
  });

  /* ---------- Delivery estimate (business days) ---------- */
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };
  $$('[data-delivery]').forEach((el) => {
    const min = Number(el.dataset.min), max = Number(el.dataset.max);
    if (!min || !max) return;
    const fmt = { month: 'short', day: 'numeric' };
    const a = addBusinessDays(new Date(), min).toLocaleDateString(undefined, fmt);
    const b = addBusinessDays(new Date(), max).toLocaleDateString(undefined, fmt);
    el.textContent = `${a} – ${b}`;
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (!el.dataset.url || el.children.length) return;
    try {
      const r = await fetch(el.dataset.url);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) { /* no-op */ }
  });
})();
